/**
 * nova.tsx — a porta ÚNICA para lançar despesa, pelo menu.
 *
 * Até 27/08/2026 existiam dois formulários e **nenhum caminho até eles**: quem
 * estava logado não conseguia lançar despesa pelo app, só pelo link público
 * (`/public/lancar-despesa`). `/despesas/nova` era alcançável apenas pelo
 * atalho do rodapé do app instalado, e `/despesas/lancar`, por ninguém.
 *
 * Decisão dele (27/08): *"todo mundo tem que ter o formulário de despesas... todo
 * mundo tem que poder entrar e criar uma despesa"*. Então o menu ganha um item
 * só, e QUEM ESCOLHE O ARRANJO É O APARELHO — não a pessoa, que não tem por que
 * saber que existem dois.
 *
 * ⚠️ A ESCOLHA É CONGELADA NA ENTRADA, de propósito, e é por isso que aqui se
 * usa `ehCelularAgora()` e não `usarCelular()`. O aviso está escrito em
 * `lib/tela.ts`: trocar de arranjo troca o COMPONENTE, e componente novo nasce
 * sem o que a pessoa digitou. Reagir ao giro do aparelho apagaria a despesa que
 * o instalador está preenchendo em campo — exatamente quem mais gira o celular.
 * Quem quiser o formulário de escritório de propósito continua tendo
 * `/despesas/lancar`, que é rota fixa.
 */
import { useState } from 'react';
import { ehCelularAgora } from '@/lib/tela';
import { DespesaFormCampoPage } from './form-celular';
import { DespesaFormCompletoPage } from './form-completo';

export function DespesaNovaPage() {
  // `useState` com inicializador: roda UMA vez, na montagem. Um `if` solto no
  // corpo re-avaliaria a cada render e traria de volta o problema que o
  // congelamento existe para evitar.
  const [celular] = useState(() => ehCelularAgora());
  return celular ? <DespesaFormCampoPage /> : <DespesaFormCompletoPage />;
}
